<template>
  <van-config-provider>
    <div id="app-container">
      <van-nav-bar
        v-if="showNavBar"
        :title="currentRouteTitle"
        left-arrow
        @click-left="onClickLeft"
        right-text="登出"
        @click-right="logout"
        class="app-navbar"
      />
      <router-view class="main-content" />
    </div>
  </van-config-provider>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
// 只导入需要的方法，避免冲突
import { showConfirmDialog, showNotify } from 'vant'; // 使用 showConfirmDialog

const route = useRoute();
const router = useRouter();

const showNavBar = computed(() => route.meta.requiresAuth);

const currentRouteTitle = computed(() => {
  if (route.name === 'LibrarianList') return '馆员慰问台账';
  if (route.name === 'LibrarianEdit') return '编辑馆员信息'; 
  return '应用';
});

const onClickLeft = () => {
  // 确保 route.meta.backRoute 存在且是一个有效的路由名称
  if (route.meta.backRoute && router.hasRoute(route.meta.backRoute)) {
    router.push({ name: route.meta.backRoute });
  } else {
    router.back();
  }
};

const logout = () => {
  showConfirmDialog({ // 使用 showConfirmDialog
    title: '确认',
    message: '您确定要登出吗？',
    // confirmButtonColor: '#1989fa', // 可选：自定义按钮颜色
  })
    .then(() => {
      // on confirm
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      showNotify({ type: 'success', message: '已登出' });
      router.push('/login');
    })
    .catch(() => {
      // on cancel - 用户点击了取消按钮或关闭了弹窗
      console.log('Logout cancelled by user.');
    });
};
</script>

<style>
#app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.main-content {
  flex-grow: 1;
  overflow-y: auto;
  padding: var(--van-padding-sm);
  box-sizing: border-box;
}
.app-navbar .van-nav-bar__title {
  font-weight: bold;
}
.app-navbar .van-nav-bar__text,
.app-navbar .van-nav-bar__arrow {
  font-size: var(--van-font-size-md);
  color: var(--van-primary-color);
}
.van-nav-bar {
  flex-shrink: 0;
}
</style>